module.exports = __webpack_public_path__ + "assets/visa.127bd379.svg";